import { Check } from "@mui/icons-material";
import { FC, RefObject } from "react";
import { FormProvider } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

import { IRideDto } from "@ryde/shared";

import { DropdownTemplate } from "../../../../dynamic-forms";
import { RideBulkMoveFields } from "./ride-station-bulk-actions.models";
import { RideStationBulkBackButton } from "./ride-station-bulk-back-button";
import { BulkMoveFormStyled } from "./ride-stations.styled";
import { useRideStationBulkMove } from "./use-ride-station-bulk-move";

interface IRideStationBulkMoveFormProps {
  rideDto: Partial<IRideDto>;
  backButtonRef: RefObject<HTMLButtonElement>;
  onBack: () => void;
}

export const RideStationBulkMoveForm: FC<IRideStationBulkMoveFormProps> = ({
  rideDto,
  backButtonRef,
  onBack,
}) => {
  const { t } = useTranslation();
  const {
    formMethods,
    directionLabelTranslated,
    moveTargetDropdownList,
    moveTargetDisabledValues,
    targetRidesDropdownList,
    isExistingRideTarget,
    movePassengersHandler,
  } = useRideStationBulkMove(rideDto);

  return (
    <BulkMoveFormStyled>
      <div className="bulk_panel_header">
        <RideStationBulkBackButton buttonRef={backButtonRef} onClick={onBack} />
        <span className="bulk_panel_title">
          <Trans
            i18nKey="ride.BULK_MOVE_PASSENGERS_TITLE"
            values={{ direction: directionLabelTranslated }}
            components={{ direction: <span className="bulk_move_direction" /> }}
          />
        </span>
      </div>

      <FormProvider {...formMethods}>
        <div className="bulk_move_fields">
          <DropdownTemplate
            name={RideBulkMoveFields.moveTarget}
            size="small"
            labelTranslated={t("ride.BULK_MOVE_TARGET_LABEL")}
            formAttributes={{
              selectItems: moveTargetDropdownList,
              disabledValues: moveTargetDisabledValues,
              skipDropdownItemsTranslation: true,
            }}
          />

          {isExistingRideTarget && (
            <DropdownTemplate
              name={RideBulkMoveFields.targetRideId}
              size="small"
              labelTranslated={t("ride.BULK_MOVE_EXISTING_RIDE_LABEL")}
              formAttributes={{
                selectItems: targetRidesDropdownList,
                skipDropdownItemsTranslation: true,
              }}
            />
          )}
        </div>

        <div className="bulk_move_actions">
          <button
            type="button"
            className="perform_bulk_action_button"
            onClick={movePassengersHandler}
          >
            {t("ride.BULK_MOVE_APPLY_BUTTON")}
            <Check />
          </button>
        </div>
      </FormProvider>
    </BulkMoveFormStyled>
  );
};
